<!doctype html>
<section>
    <div class="row py-4 px-5" style="background: #fff;margin: 0;">
        <div class="col-12 py-1  px-0">
            <h3>SOBRE MÍ</h3>
        </div>
    
        <div class="col-12 col-sm-12 col-md-6 col-lg-5 col-xl-5 py-3 px-0">
            <div class="container-left-about ">
                <h4 class="px-4">
                    <em><i>PATRICIA VALDEBENITO PANES</i></em>
                </h4>
    
                <div class="container-img-about pt-4">
                    <img src="../../assets/img/3EVErORx_400x400.jpg" alt="photograph patricia valdebenito developer" class="img-fluid img-developer">
                </div>
            </div>
        </div>
    
        <div class="col-12 col-sm-12 col-md-6 col-lg-7 col-xl-7 description-about py-3  px-0">
            <p>
               <b>¡Hola!, ¿Cómo están?.</b> 
                <br><br>
                En el 2019 curse un Bootcamp de desarrollo web en <b>Javascript</b>, trabajando con 
                proyectos en los cuales aprendí las bases de Javascript, framework <b>Angular</b> , NodeJs, CSS y otros 
                <a routerLink="/skill"><b>Skill</b></a>.
                <br><br>

                Antes de comenzar en el mundo del desarrollo, curse <b>Ingeniería  en Minería en Universidad de Santiago de Chile</b>,
                 y <b>Licenciatura en Pedagogía con Mención en Matemáticas</b>. Sin duda, la programación, este inmenso y expectante
                  mundo de la tecnología ha generado grandes ilusiones en mi futuro profesional. 
                  <br>
<br>
                  Actualmente me encuentro en búsqueda de nuevas oportunidades laborales, me gustaría ser parte de un 
                  equipo en el cual pueda desarrollarme, aprender, crecer en mis conocimientos y que no existan límites.
      
                  Quiero aportar desde mis conocimientos y trabajar en conjunto, por ello te invito a conocer mis proyectos 
                  y redes profesionales. <br>
                  Si quieres  contactarme o regalar un feedback del portafolio, 
                  <br> <b>¡Yo Feliz! </b>
               
            </p>
            <div style="display: flex; justify-content: center;margin-top: 3em;">
                <a class="btn  button-home-project" routerLink="/project">¡ Ver Proyectos !</a>
               

            </div>
            <div class="mt-4">
                <app-redsocial></app-redsocial>
            </div>
          
         
        </div>
    </div>
</section>
